"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ContentBlockList", {
  enumerable: true,
  get: function get() {
    return _styled.ContentBlockList;
  }
});
exports.LibraryBlock = exports.ItemName = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styled = require("../ContentBlockList/styled");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ItemName = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n\n    color: #fff;\n    font-weight: 500;\n    margin: 5px 0 0;\n\n    span {\n        flex: 1;\n        background-color: #666;\n        padding: 5px;\n    }\n\n    button {\n        margin-left: 5px;\n        flex: 0;\n        padding-top: 2px;\n        padding-bottom: 3px;\n        border-radius: 0;\n    }\n"])));

exports.ItemName = ItemName;

var LibraryBlock = _styledComponents["default"].li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    .component-border {\n        border-style: none;\n    }\n\n    .ory-toolbar-draggable > .ory-row > .ory-cell {\n        background-color: #ffffff;\n    }\n\n    .ory-toolbar-draggable {\n        width: 100%;\n    }\n\n    .ory-cell-inner {\n        color: ", ";\n        font-size: 0.2em;\n        overflow: hidden;\n\n        p {\n            font-size: 2em;\n            overflow: hidden;\n            display: -webkit-box;\n            -webkit-line-clamp: 4;\n            -webkit-box-orient: vertical;\n            max-height: 90px;\n            text-overflow: -o-ellipsis-lastline;\n            margin-bottom: 2px;\n        }\n\n        .component-wrapper {\n            pointer-events: none;\n\n            * {\n                font-size: 10px !important;\n                min-height: 0;\n                max-height: 100%;\n\n                &[class*='cBand'] {\n                    padding-top: 5px;\n                    padding-bottom: 5px;\n\n                    .btn-group {\n                        transform: scale(0.4);\n                    }\n\n                    .col-xl-7 {\n                        flex: 0 0 100%;\n                        max-width: 100%;\n                    }\n                }\n            }\n\n            h1,\n            h2,\n            h3,\n            h4,\n            h5,\n            h6 {\n                margin-top: 1rem;\n            }\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.brandDark;
});

exports.LibraryBlock = LibraryBlock;